import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/shell.css";
import "./styles/auth.css";
import "./styles/research.css";
import "./styles/docpanel.css";
import "./styles/documents.css";
import "./styles/draft.css";
import "./styles/doceditor.css";
import "./styles/compliance.css";
import "./styles/memory.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
